import {apiUrl} from './../../constants/apiUrl'
import {logKafka, catchJSException} from './../../service/logService'
import {redirectTo,removeHistoryAndredirectTo} from './redirection'
import { Pages } from './../../constants/actionType'
import { store } from "../../../src/index" /**importing store for reducer values */


export const errorAction = (error, page, errorMessage, logName, cookieVal, dispatch, isQueryStringLBO, QueryString) => {
    try {
        const isHoaFlag = store.getState().loopQual.ecLQResponse.hoaFlag === "V"?true:false
        const isVECAddress = store.getState().loopQual?.runtimeKey?.enableVECAddress === "Y" ? true : false;
        let getErrorLogUrl = apiUrl().kafkaErrorAppLogs;
        if (cookieVal === '')
            cookieVal = "VisitIdEmpty"
        logKafka(error, page, errorMessage, getErrorLogUrl, logName, cookieVal);
        // if ((error === "LBO" || isQueryStringLBO) && (window.location.pathname.indexOf('/change/') > -1 )) {
        //     let BauUrl = Pages.RegistrationbridgeEC + "?URCSource=ATOM";
        //     redirectTo(BauUrl, dispatch)
        // }
        // else
        if(window && window.location && window.location.pathname && !window.location.pathname.includes("/lbo")){
        if (isQueryStringLBO&&!isHoaFlag) {
            let lboUrl = Pages.LBO + `?msg=${errorMessage}`;
            if(page === "validateSignin"){
               removeHistoryAndredirectTo(lboUrl, dispatch)
            }
            else{
               redirectTo(lboUrl, dispatch)
            }
        }
        else if (error === "LBO"&&!isHoaFlag) {
            if(page === "validateSignin"){
              removeHistoryAndredirectTo(Pages.LBO +`?msg=${errorMessage}`, dispatch)
            }
            else{
              redirectTo(Pages.LBO +`?msg=${errorMessage}`, dispatch)
            }
        }
        if (error === "LBO"&&!isHoaFlag) {
            dispatch({
                type: 'LBO',
                value: errorMessage,
                frompage: page
            });
        }
       /* FIOSVEC-4 - enabling for VEC orders */
       if(error === "LBO" && isHoaFlag && isVECAddress){
            if(page === "validateSignin"){
               removeHistoryAndredirectTo(Pages.lbohoa +`?msg=${errorMessage}`, dispatch) 
            }
            else{
               redirectTo(Pages.lbohoa +`?msg=${errorMessage}`, dispatch)
            }
        }
        }
    }
    catch (ex) {
        catchJSException('error', cookieVal, 'action_errorAction', ex);

    }
};

export const clientException = (dispatch,errorDetails) => {
    //Log Page Level Kafka Issue  here
    //logKafka(error,page,errorMessage,getErrorLogUrl,logName,cookieVal);       
    dispatch({
        type: 'CLIENT_EXCEPTION',
        value: errorDetails
    });
};

export const logout = (dispatch) => {
    dispatch({ type: "CLEAR_STORE" });
    redirectTo(Pages.CheckLQ, dispatch);
}
export const logoutSmartSave = (dispatch,mon) => {
    dispatch({ type: "CLEAR_STORE" });
    redirectTo(Pages.ResumeCart+"?xpsid="+mon+"&ordertype=SmartSave&XpsSource=SaveOverlay", dispatch);
}

export const logOutVendorFlow = (dispatch)=>{
    dispatch({ type: "CLEAR_STORE" });
}
